import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { AppOfferService } from '../services/app-offer.service';

export const productFieldNamesTranslationGuard: CanActivateFn = async () => {
	const router = inject(Router);
	const appOfferService = inject(AppOfferService);
	try {
		await firstValueFrom(appOfferService.loadConfigurationFieldNames());
		return true;
	} catch (err) {
		console.error('unable to load configuration field names', err);
		return router.createUrlTree(['/']);
	}
};
